import React, { useEffect, useRef, useState } from "react";
import PublicHeader from "./public-header/PublicHeader";
import ICImage from "../core-component/ICImage";
import ICPureImage from "../core-component/ICPureImage";
import {
  affordableIcon,
  assesmentIcon,
  communitySupportIcon,
  downChevronIcon,
  individualIcon,
  kidProgramIcon,
  offlineEventIcon,
  wellnessLibraryIcon,
  wellnessWarriorIcon,
  zoomSessionIcon,
} from "../assets/icons/SvgIconList";
import UseTranslationHook from "../hooks/UseTranslationHook";
import PublicServiceCarousel from "../components/PublicServiceCarousel";
import PublicTrendingServiceCarousel from "../components/PublicTrendingServiceCarousel";
import { IServiceForSubCategory } from "../screens/product-services/Web/ProductServiceDetailsWebController";
import { fetchPublicServiceApi } from "./offerings/OfferingController";
import { publicRoute } from "../routes/RoutePublic";
import usePaginationHook from "../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../utils/AppConstants";
import CopyrightFooter from "../components/common/CopyrightFooter";
import { gsap } from "gsap";
import { PUBLIC_HEADER_TABS, PUBLIC_TABS } from "../utils/AppEnumerations";
import Loader from "../components/common/Loader";
import { Link, useLocation } from "react-router-dom";
import HomePublicHeader from "./public-header/HomePublicHeader";
import Countdown from "../components/Countdown";
import UseMobileLayoutHook from "../hooks/UseMobileLayoutHook";
const Home = () => {
  const { t } = UseTranslationHook();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [publicLoader, setPublicLoader] = useState(true);
  const [servicesList, setServicesList] = useState<IServiceForSubCategory[]>(
    []
  );
  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Twelve),
      current_page: 1,
      sort_by: "",
      order_by: "DESC",
    },
  });
  // need this comment in future
  // useEffect(() => {
  //   fetchPublicServiceApi(
  //     setServicesList,
  //     setLoading,
  //     pagination,
  //     setPagination,
  //     servicesList,
  //     true
  //   );
  //   setTimeout(async () => {
  //     setPublicLoader(false);
  //   }, 2000);
  // }, []);
  useEffect(() => {
    document.title = PUBLIC_TABS.Home;
    gsap.to(`.video-section`, {
      opacity: 1,
      scale: 1,
      ease: "power2.out",
      duration: 2,
    });
  });
  const section = location.state?.section;
  useEffect(() => {
    if (section) {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [section]);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const targetDate = '2024-07-27T03:30:00';
  const { isMobile } = UseMobileLayoutHook()
  return (
    <div className="bg-skin-home-bg w-full scroll-smooth video-container">
      {!loading ? (
        <Loader />
      ) : (
        <>
          <div >
            <HomePublicHeader scrollContainerRef={scrollContainerRef} activeTab={PUBLIC_HEADER_TABS.Home} />
          </div>
          <div ref={scrollContainerRef} className="overflow-y-scroll remove-scrollbar-width h-screen w-full">
            <div className="h-screen w-full">
              <div className="flex justify-center flex-col lg:h-full h-[85%] items-center w-full">
                <div className="flex flex-col justify-center items-center h-full w-full">
                  <div className="flex mb-12 justify-center w-full">
                    <ICPureImage
                      className="lg:h-[300px] h-[200px] object-contain"
                      src={require("../assets/image/vp-logo-square.png")}
                    />
                  </div>
                  <div className=" tracking-widest mb-12  flex justify-center items-center">
                    <div className="lg:text-5xl text-3xl flex justify-center items-center text-skin-insights">{t("coming_soon")}</div>
                  </div>
                  <div className=" w-full mb-12  flex justify-center">
                    <Countdown targetDate={targetDate} />
                  </div>
                </div>
                <div className="w-full flex items-end justify-center self-end">
                  <div className="lg:w-28 w-14 bounce">{downChevronIcon}</div>
                </div>
              </div>
            </div>
            <div className="w-full video-container">
              <video
                src={require("../assets/image/UNLOCK THE WELLNESS AGE 2.0_1920x1080_4MB.mp4")}
                autoPlay
                loop
                playsInline
                muted
                className="h-full w-full scale-50 relative video-section"
              />

            </div>
            {/* need this comment in future */}
            {/* <div className="w-full">
              <ICPureImage
                className="w-full object-contain"
                src={require("../assets/image/Stress is “Not” Okay-18.png")}
              />
              <div className="mb-5">
                <ICPureImage
                  className="w-full object-contain"
                  src={require("../assets/image/3.png")}
                />
              </div>
              <div className="mb-5">
                <ICPureImage
                  className="w-full object-contain"
                  src={require("../assets/image/4.png")}
                />
              </div>
              <ICPureImage
                className="w-full object-contain"
                src={require("../assets/image/5.png")}
              />
            </div> */}
            {/* {servicesList && servicesList.length > 0 && (
              <div className="mt-12 relative">
                <div className="flex flex-col justify-center w-full z-[99]">
                  <div className="text-skin-title-insights tracking-widest text-center lg:text-5xl text-3xl z-[99]">
                    {t("services_we_offer")}
                  </div>
                  <div className="desktop-carousel">
                    <PublicServiceCarousel items={servicesList} />
                  </div>
                  <div className="mobile-carousel">
                    <PublicTrendingServiceCarousel items={servicesList} />
                  </div>
                </div>
              </div>
            )} */}
            {/*  Our Aim Section*/}
            <hr />
            <div className="relative">
              <div className="flex lg:flex-row flex-col">
                <div className="lg:w-[40%] mr-3 flex justify-center">
                  <ICImage
                    className="w-full xl:object-contain"
                    src={require("../assets/image/Our Mission.jpeg")}
                    scaled={false}
                  />
                </div>
                <div className="lg:w-[60%]">
                  <div className="flex tracking-widest text-justify flex-col p-3 justify-center items-center h-full text-skin-title-insights">
                    <div className="flex justify-center lg:text-4xl text-2xl items-center lg:mt-0 mt-4 text-skin-insights">{t("our_mission")}</div>
                    <div className="lg:text-xl lg:mt-12 text-sm mt-6">{t("our_aim_content")}</div>
                    <div className="lg:text-xl lg:mt-12 text-sm my-6">{t("here_to_elevate")}</div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="relative">
              <video
                src={require("../assets/image/our aim.mp4")}
                autoPlay
                playsInline
                loop
                muted
                className="w-full relative"
              />
            </div>
            <hr />
            <ICPureImage
              className="w-full object-contain lg:mt-6 mt-0"
              src={require(isMobile ? "../assets/image/trainers.png" : "../assets/image/6 before footer.png")}
            />
            <div>
              <div className="w-full flex justify-center lg:mb-14 mb-10">
                <div className="bg-white lg:p-4 p-1 lg:mb-4 mt-4 lg:px-16 px-6 rounded-lg cursor-pointer"><Link className="lg:text-2xl text-xl" to={"https://forms.gle/fkP2CNQRnmy99F5m6"} target="_blank">{t("join")}</Link></div>
              </div>
            </div>
            {/* need this comment in future */}
            {/* <ICPureImage
              className="w-full object-contain"
              src={require("../assets/image/7.png")}
            /> */}
            <div>
              <hr />
              <div className=" relative">
                <div className="pb-12">
                  <div className="flex flex-col justify-center w-full z-[99]">
                    <div className="text-skin-title-insights mt-12 tracking-widest text-center lg:text-5xl text-2xl z-[99]">
                      {t("membership_benefits")}
                    </div>
                    <div className="text-skin-title-insights tracking-widest mt-12 text-center lg:text-lg text-sm z-[99]">
                      {t("membership_benefits_content")}
                    </div>
                  </div>
                  <div className="flex justify-center w-full">
                    <div className="grid grid-cols-2 xl:grid-cols-3 gap-7 justify-items-start p-3 mt-14">
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{individualIcon}</div>
                          <div className="lg:text-lg text-sm  tracking-widest text-skin-title-insights">
                            {t("individual_programs")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{kidProgramIcon}</div>
                          <div className="lg:text-lg text-sm tracking-widest text-skin-title-insights">
                            {t("kids_programs")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{zoomSessionIcon}</div>
                          <div className="lg:text-lg text-sm tracking-widest text-skin-title-insights">
                            {t("zoom_connect")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{wellnessWarriorIcon}</div>
                          <div className="lg:text-lg text-sm tracking-widest text-skin-title-insights">
                            {t("certified_trainers_connect")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{communitySupportIcon}</div>
                          <div className="lg:text-lg text-sm  tracking-widest text-skin-title-insights">
                            {t("community_support")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{offlineEventIcon}</div>
                          <div className="lg:text-lg text-sm tracking-widest text-skin-title-insights">
                            {t("offline_sessions")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{wellnessLibraryIcon}</div>
                          <div className="lg:text-lg text-sm tracking-widest text-skin-title-insights">
                            {t("wellness_library")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="lg:h-9 lg:w-9 h-7 w-7">{affordableIcon}</div>
                          <div className="lg:text-lg text-sm  tracking-widest text-skin-title-insights">
                            {t("affordable_and_convenient")}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-1 flex flex-col text-skin-title-insights justify-start items-start">
                        <div className="flex justify-start gap-6 items-center text-skin-title-insights">
                          <div className="h-9 w-9">{assesmentIcon}</div>
                          <div className="lg:text-lg text-sm tracking-widest text-skin-title-insights">
                            {t("real_time_assessment_and_analysis")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <CopyrightFooter />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
